import * as React from "react"

const Question = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0zm6.51 4a.825.825 0 100-1.65.825.825 0 000 1.65zm-.677-6.674c.211-.19.586-.307.94-.265.337.04.554.204.628.471v.001c.061.222.031.349-.02.455-.07.14-.186.267-.386.486l-.01.012c-.19.208-.429.475-.613.835-.189.367-.311.812-.311 1.377a.481.481 0 10.963 0c0-.417.088-.71.205-.938.12-.236.28-.421.467-.625l.044-.049c.165-.179.372-.405.504-.672.161-.328.206-.698.085-1.136-.205-.75-.837-1.101-1.443-1.173-.59-.07-1.253.105-1.698.506a.481.481 0 00.645.715z"
      fill="currentColor"
    />
  </svg>
)

export default Question
